import React from 'react';
import '../styles/Galeria.css';

import imagen_01 from '../imagenes/galeria/horizontal/imagen01.jpg';
import imagen_02 from '../imagenes/galeria/horizontal/imagen02.jpg';
import imagen_03 from '../imagenes/galeria/horizontal/imagen03.jpg';
import imagen_04 from '../imagenes/galeria/horizontal/imagen04.jpg';
import imagen_05 from '../imagenes/galeria/horizontal/imagen05.jpg';
import imagen_06 from '../imagenes/galeria/horizontal/imagen06.jpg';


const imagenes = [
  { src: imagen_01, titulo: 'Ocaso en la tierra del Qorilazo' },
  { src: imagen_02, titulo: 'Madre Chumbivilcana' },
  { src: imagen_03, titulo: 'Amazonas de Chumbivilcas' },
  { src: imagen_04, titulo: 'Chumbivilcano Valiente' },
  { src: imagen_05, titulo: 'Aguerrido Qorilazo' },
  { src: imagen_06, titulo: 'Ocaso del Qorilazo' },
];

function Galeria(){
  return (
    <section className="galeria-seccion">
      <h1 className="titulo">Galería del Bicentenario</h1>
      <div className="galeria-grid">
        {imagenes.map((img, i) => (
          <div className="imagen-item" key={i}>
            <img src={img.src} alt={img.titulo} />
            <div className="overlay">
              <h3>{img.titulo}</h3>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

export default Galeria; 